<template>
  <MainLayout :style="style">
    <div class="exchange-view">
      <div class="top-title">
        <h1>Resgatar brinde</h1>
      </div>

      <div class="exchange-content">
        <p class="exchange-instructions">Selecione o brinde que você deseja resgatar e aperte no botão "Resgatar" para confirmar.</p>

        <p class="exchange-message" v-if="products.length === 0">{{ listMessage }}</p>

        <div class="product-grid" v-else>
          <div class="product-item" v-for="product of products" :key="product._id"
            :class="{ selected: selectedProduct && selectedProduct._id === product._id }"
            @click="selectProduct(product)">
            <div class="image-box" v-if="product.images && product.images[0]">
              <img :src="getImageThumbUrl(product.images[0])" alt="" />
            </div>
            <div class="img-empty" v-else></div>
            <div class="info">
              <h3>{{ product.name }}</h3>
            </div>
          </div>
        </div>
      </div>

      <center class="exchange-actions">
        <button class="clean" @click="historyBack">Voltar</button>
        <button class="primary" :disabled="!selectedProduct || isExchangingGift" @click="exchange" >Resgatar</button>
      </center>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from "../layout/main";
import CampaignMixin from "../mixins/campaign.mixin.js";
import userMixin from "../mixins/user.mixin";

export default {
  mixins: [CampaignMixin, userMixin],
  components: {
    MainLayout,
  },
  data() {
    return {
      ticketId: null,
      ticket: null,
      products: [],
      selectedProduct: null,
      listMessage: "Carregando",
      isExchangingGift: false,
    };
  },
  mounted() {
    this.ticketId = this.$route.params.id;
    this.loadTicket();
    if (this.campaign && this.campaign.slug) this.loadProducts();
  },
  watch: {
    campaign() {
      this.loadProducts();
    },
  },
  methods: {
    loadTicket() {
      const self = this;
      this.getTicket(this.ticketId).then((response) => {
        if (response) self.ticket = response.ticket;
      });
    },
    loadProducts() {
      const self = this;
      this.listProducts().then((response) => {
        self.products = response.product_list || [];
        self.listMessage = "Nenhum brinde disponível para resgate";
      });
    },
    selectProduct(product) {
      this.selectedProduct = product;
    },
    exchange() {
      if (!this.selectedProduct) return;
      const self = this;
      this.$swal({
        icon: "warning",
        title: "Atenção",
        text: "Ao confirmar, o resgate deste brinde não poderá ser desfeito.",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) self.confirmExchange();
      });
    },
    confirmExchange() {
      const self = this
      self.isExchangingGift = true
      self.updateTicketStatus(self.ticket, self.selectedProduct, 'EXCHANGED').then((response) => {
        if (response) {
          self.ticket = response.ticket
          self.$swal({
            icon: 'success',
            title: 'Sucesso',
            text: 'Brinde resgatado com sucesso.',
            // footer: '<a href>Why do I have this issue?</a>'
            showCancelButton: false,
            confirmButtonColor: '#053360',
            confirmButtonText: 'Ok'
          }).then((result) => {
            if (result.isConfirmed) {
              window.open(this.campaignHome + '/cupons', "_self")
            }
          })
        }
        self.isExchangingGift = false
      })
    },
  },
};
</script>

<style scoped lang="scss">
@import "../scss/colors.scss";

.exchange-view {
  padding-bottom: 150px;
}

.exchange-actions {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  gap: 20px;
}

.exchange-content {
  padding: 20px;
  max-width: 900px;
  margin: 0 auto;

  .exchange-instructions {
    text-align: center;
    padding-inline: 20px;
    margin-bottom: 30px;
  }

  .exchange-message {
    text-align: center;
  }

  .product-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 30px;
    padding-inline: 20px;
  }

  .product-item {
    background: var(--bg-color-light);
    position: relative;
    aspect-ratio: 1 / 1;
    cursor: pointer;
    border: 3px solid transparent;
    border-radius: 5px;
    overflow: hidden;

    &.selected {
      border-color: var(--primary);
    }

    .image-box {
      width: 100%;
      height: 100%;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .img-empty {
      width: 100%;
      height: 100%;
      background-color: var(--bg-color-dark);
    }

    .info {
      position: absolute;
      bottom: 0px;
      width: 100%;
      padding: 10px;
      background: var(--secundary);

      h3 {
        font-size: 13pt;
        font-weight: bold;
        color: #000;
      }
    }
  }
}

@media (max-width: 768px) {
  .exchange-content {
    padding: 20px 0px;

    .product-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
    }
  }
}
</style>
